'use strict';

var Params = function Params(data, forceWidth) {
  return function (containerWidth) {
    var padding = {
      top: 10,
      bottom: 55,
      left: 75,
      right: 30
    };
    var barWidth = 50;
    var width = containerWidth - (padding.left + padding.right);
    if (forceWidth) {
      width = barWidth * (data[0].curveData ? data[0].curveData.length : data.length);
      containerWidth = width + padding.left + padding.right;
    }
    var height = 200;
    return {
      width: width,
      height: height,
      containerWidth: containerWidth,
      containerHeight: height + padding.top + padding.bottom,
      padding: padding,
      yNumberOfTicks: 5,
      yAxisShift: 12,
      yAxisLabelShift: 55,
      forceHeight: true,
      forceWidth: forceWidth,
      direction: 'horyzontal!'
    };
  };
};
module.exports = Params;